<template>
  <div>
    <el-card>
      <el-form inline size="small">
        <el-form-item :label="$t('名称')">
          <el-input :placeholder="$t('名称')" clearable v-model="searchFrom.name" />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="$refs.list.handleSearch()">{{$t('查询')}}</el-button>
          <el-button @click="$refs.list.reset()">{{$t('重置')}}</el-button>
        </el-form-item>
      </el-form>

      <div class="flex-end mb16">
        <el-button size="small" type="primary" @click="$router.push('add')">{{$t('新增')}}</el-button>
        <el-button size="small" type="danger" @click="handleBatchDelete">{{$t('删除')}}</el-button>
      </div>

      <div style="height: 500px">
        <table-list
            ref="list"
            :height="300"
            :search-params="searchFrom"
            @query="loadLevelList"
            @selection-change="selection = $event"
            :data="tableData">
          <el-table-column type="selection" width="90" />
          <el-table-column :label="$t('序号')" type="index" width="90" />
          <el-table-column :label="$t('等级名称')" prop="name"/>
          <el-table-column :label="$t('积分')" prop="integral"/>
          <!--        <el-table-column :label="$t('等级权益')" prop="equity"/>-->
          <el-table-column :label="$t('创建时间')" prop="createTimeStr"/>
          <el-table-column :label="$t('操作')" min-width="20">
            <template v-slot="{row}">
              <div class="fb-link-flex">
                <el-link :underline="false" type="primary" @click="$router.push('detail?code=' + row.code)">{{$t('查看')}}</el-link>
                <el-link :underline="false" type="primary" @click="$router.push('edit?code=' + row.code)">{{$t('编辑')}}</el-link>
                <el-link :underline="false" type="danger" @click="handleDelete(row)">{{$t('删除')}}</el-link>
              </div>
            </template>
          </el-table-column>
        </table-list>
      </div>
    </el-card>

    <integral-rule class="mt16"/>
  </div>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import IntegralRule from "@/components/member-level/IntegralRule";
import {request, requestByTip} from "@/config/request";

export default {
  name: "MemberLevelList",
  components: {IntegralRule, TableList},
  data() {
    return {
      tableData: [],
      searchFrom: {},
      selection: [],
    }
  },
  methods: {
    async handleDelete(row) {
      try {
        await requestByTip(this.$api.vipLevel.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest(1);
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      try {
        let codes = this.selection.map(item => item.code);
        if (!codes.length) {
          this.$message.error(this.$t('请选择要删除的数据'));
          return;
        }
        await requestByTip(
            this.$api.vipLevel.batchDelete,
            codes,
            {isJson: true},
            {message: this.$t('您现在正在进行批量删除操作, 是否继续?')}
        );
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest(codes.length);
      } catch (e) {
        console.error(e);
      }
    },

    // 等级列表
    async loadLevelList(params, setTotal) {
      try {
        const res = await request(this.$api.vipLevel.list, params);
        this.tableData = res.vipLevels.map(item => {
          item.createTimeStr = this.$moment(item.createTime).format("YYYY-MM-DD HH:mm:ss");
          return item;
        })
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.log(e);
      }
    }
  }
}
</script>

<style scoped>

</style>
